import { call, put, select, takeLatest } from "redux-saga/effects";
import iq_api_v2 from "../../../../services/iqApiV2";
import { FETCH_WIN_OPPORTUNITIES_REQUEST, fetchWinOpportunitiesFailure, fetchWinOpportunitiesSuccess } from "../../actions/opportunities/winOpportunitiesActions";
import { bannerService } from "../../../../context/BannerContext";




async function findWinOpportunity(clientName, accountName, userId,type) {
    const data = {
      client: clientName,
      account: accountName,
      user_id: userId,
      type: type
    };
  
    // console.log("data",data)
    try {
      const response = await iq_api_v2.post('/opportunities/fetch', {}, {"params" : data} );
      // console.log("response : ", response);

      // console.log('Response:', response.data);
      return response?.data
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  }

// Worker Saga
function* fetchWinOpportunitiesSaga() {
  try {
    const payload = yield select(
      (state) => state?.winOpportunitiesReducer?.payload
    );
    const {  clientName,accountName,userId,type } = payload;
    const data = yield call(
        findWinOpportunity,
        clientName,accountName,userId,type
    );
    yield put(fetchWinOpportunitiesSuccess(data));
        // yield call(
        //   [bannerService, bannerService.publish],
        //   {
        //     message:
        //     "Win Opportunities loaded",
        //     title:"Alert",
        //     type: 'info',
        //     duration: 1000
        //   }
        // )
  } catch (error) {
    yield put(fetchWinOpportunitiesFailure(error.message));
  }
}

// Watcher Saga
export function* watchWinOpportunitiesSaga() {  
  yield takeLatest(FETCH_WIN_OPPORTUNITIES_REQUEST, fetchWinOpportunitiesSaga);
}
